// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let CardV5 = require("../common/Components/CardV5.bs.js");
let FormV5 = require("../../uikit/reason/atoms/Form/FormV5.bs.js");
let Scalars = require("../../scalars/Scalars.bs.js");
let RelayEnv = require("../../RelayEnv.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Formality = require("../../vendor/re-formality/Formality.bs.js");
let Form__Input = require("../../uikit/reason/atoms/Form/Form__Input.bs.js");
let Form__Helpers = require("../../reason/common/Form/Form__Helpers.bs.js");
let Heading__Jsx3 = require("../../uikit/reason/helpers/Heading__Jsx3.bs.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let Form__Components = require("../../reason/common/Form/Form__Components.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let TMPUIKIT____Page = require("../../temporaryUIKit/TMPUIKIT____Page/TMPUIKIT____Page.bs.js");
let JsxRuntime = require("react/jsx-runtime");
let AccountMemberUtils = require("./AccountMemberUtils.bs.js");
let RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
let Formality__Debouncer = require("../../vendor/re-formality/Formality__Debouncer.bs.js");
let Primitive_exceptions = require("@rescript/runtime/lib/js/Primitive_exceptions.js");
let Formality__ReactUpdate = require("../../vendor/re-formality/Formality__ReactUpdate.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
let SubusersAddUserFormQuery_graphql = require("../../__generated__/SubusersAddUserFormQuery_graphql.bs.js");
let SubusersAddUserForm_account_graphql = require("../../__generated__/SubusersAddUserForm_account_graphql.bs.js");
let SubusersPageAccountsList_account_graphql = require("../../__generated__/SubusersPageAccountsList_account_graphql.bs.js");
let SubusersAddUserForm_AddMemberV5Mutation_graphql = require("../../__generated__/SubusersAddUserForm_AddMemberV5Mutation_graphql.bs.js");

let convertVariables = SubusersAddUserFormQuery_graphql.Internal.convertVariables;

let convertResponse = SubusersAddUserFormQuery_graphql.Internal.convertResponse;

let convertWrapRawResponse = SubusersAddUserFormQuery_graphql.Internal.convertWrapRawResponse;

let use = RescriptRelay_Query.useQuery(convertVariables, SubusersAddUserFormQuery_graphql.node, convertResponse);

let useLoader = RescriptRelay_Query.useLoader(convertVariables, SubusersAddUserFormQuery_graphql.node, prim => prim);

let usePreloaded = RescriptRelay_Query.usePreloaded(SubusersAddUserFormQuery_graphql.node, convertResponse, prim => prim);

let fetch = RescriptRelay_Query.fetch(SubusersAddUserFormQuery_graphql.node, convertResponse, convertVariables);

let fetchPromised = RescriptRelay_Query.fetchPromised(SubusersAddUserFormQuery_graphql.node, convertResponse, convertVariables);

let retain = RescriptRelay_Query.retain(SubusersAddUserFormQuery_graphql.node, convertVariables);

let Query_emailRegistrationStatus_decode = SubusersAddUserFormQuery_graphql.Utils.emailRegistrationStatus_decode;

let Query_emailRegistrationStatus_fromString = SubusersAddUserFormQuery_graphql.Utils.emailRegistrationStatus_fromString;

let Query = {
  emailRegistrationStatus_decode: Query_emailRegistrationStatus_decode,
  emailRegistrationStatus_fromString: Query_emailRegistrationStatus_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  fetch: fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

async function validate(email) {
  let val;
  try {
    val = await fetchPromised(RelayEnv.environment, {
      email: email
    }, undefined, "network-only");
  } catch (raw_exn) {
    let exn = Primitive_exceptions.internalToException(raw_exn);
    if (exn.RE_EXN_ID === "JsExn") {
      return {
        TAG: "Error",
        _0: "something went wrong"
      };
    }
    throw exn;
  }
  let match = val.emailRegistrationStatus;
  if (match === undefined) {
    return {
      TAG: "Error",
      _0: "email is not available"
    };
  }
  let tmp = match.status;
  if (tmp === "AVAILABLE") {
    return {
      TAG: "Ok",
      _0: undefined
    };
  } else {
    return {
      TAG: "Error",
      _0: "email is not available"
    };
  }
}

let ValidateEmailAsync = {
  Query: Query,
  validate: validate
};

function SubusersAddUserForm$SubuserLimitReachedMessage(props) {
  return JsxRuntime.jsx(CardV5.make, {
    children: JsxRuntime.jsx(Heading__Jsx3.make, {
      as_: "h5",
      children: "You have reached the maximum number of allowed users. Contact support if you need to add more users to this account."
    })
  });
}

let SubuserLimitReachedMessage = {
  make: SubusersAddUserForm$SubuserLimitReachedMessage
};

function SubusersAddUserForm$OnlyAccountOwnerMessage(props) {
  return JsxRuntime.jsx(CardV5.make, {
    children: JsxRuntime.jsx(Heading__Jsx3.make, {
      as_: "h5",
      children: "Only the account owner can add users to the account."
    })
  });
}

let OnlyAccountOwnerMessage = {
  make: SubusersAddUserForm$OnlyAccountOwnerMessage
};

let convertFragment = SubusersAddUserForm_account_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, SubusersAddUserForm_account_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(SubusersAddUserForm_account_graphql.node, convertFragment, fRef);
}

let AccountFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

let convertVariables$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertVariables;

let convertResponse$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertResponse;

let convertWrapRawResponse$1 = SubusersAddUserForm_AddMemberV5Mutation_graphql.Internal.convertWrapRawResponse;

let commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, SubusersAddUserForm_AddMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let use$2 = RescriptRelay_Mutation.useMutation(convertVariables$1, SubusersAddUserForm_AddMemberV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse$1);

let AddMemberV5Mutation_accountMemberRoleInput_decode = SubusersAddUserForm_AddMemberV5Mutation_graphql.Utils.accountMemberRoleInput_decode;

let AddMemberV5Mutation_accountMemberRoleInput_fromString = SubusersAddUserForm_AddMemberV5Mutation_graphql.Utils.accountMemberRoleInput_fromString;

let AddMemberV5Mutation = {
  accountMemberRoleInput_decode: AddMemberV5Mutation_accountMemberRoleInput_decode,
  accountMemberRoleInput_fromString: AddMemberV5Mutation_accountMemberRoleInput_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  commitMutation: commitMutation,
  use: use$2
};

let genericErrorMessage = "Something went wrong when adding the user. Please try again or contact our support.";

let validators_lastName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let lastName = Form__Helpers.noneIfEmpty(param.lastName);
    if (lastName !== undefined) {
      return {
        TAG: "Ok",
        _0: lastName
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_firstName = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let firstName = Form__Helpers.noneIfEmpty(param.firstName);
    if (firstName !== undefined) {
      return {
        TAG: "Ok",
        _0: firstName
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators_email = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let email = Form__Helpers.noneIfEmpty(param.email);
    if (email === undefined) {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
    let email$1 = Scalars.EmailAddress.validate(email);
    if (email$1.TAG === "Ok") {
      return {
        TAG: "Ok",
        _0: email$1._0
      };
    } else {
      return {
        TAG: "Error",
        _0: "Please enter a valid email."
      };
    }
  },
  validateAsync: Formality__Debouncer.make(700, param => {
    let dispatch = param[2];
    let value = param[0];
    let validate = (email, param) => param.validateEmail(Scalars.EmailAddress.toString(email)).then(res => {
      if (res.TAG === "Ok") {
        return {
          TAG: "Ok",
          _0: email
        };
      } else {
        return {
          TAG: "Error",
          _0: res._0
        };
      }
    });
    Formality.Async.validateAsyncWithMetadata(value, param[1], validate, res => dispatch({
      TAG: "ApplyAsyncResultForEmailField",
      _0: value,
      _1: res
    }));
  }),
  eq: (a, b) => a === b
};

let validators_role = {
  strategy: "OnFirstSuccessOrFirstBlur",
  validate: (param, param$1) => {
    let role = param.role;
    if (role !== undefined) {
      return {
        TAG: "Ok",
        _0: role
      };
    } else {
      return {
        TAG: "Error",
        _0: "is required"
      };
    }
  }
};

let validators = {
  lastName: validators_lastName,
  firstName: validators_firstName,
  email: validators_email,
  role: validators_role
};

function initialFieldsStatuses(input) {
  return {
    lastName: "Pristine",
    firstName: "Pristine",
    email: "Pristine",
    role: "Pristine"
  };
}

function initialFieldStatuses_xxx(x) {
  return {
    lastName: "Pristine",
    firstName: "Pristine",
    email: "Pristine",
    role: "Pristine"
  };
}

function initialState(input) {
  return {
    input: input,
    fieldsStatuses: {
      lastName: "Pristine",
      firstName: "Pristine",
      email: "Pristine",
      role: "Pristine"
    },
    collectionsStatuses: undefined,
    formStatus: "Editing",
    submissionStatus: "NeverSubmitted"
  };
}

function validateForm(input, validators, fieldsStatuses, metadata) {
  let match = fieldsStatuses.lastName;
  let tmp;
  tmp = typeof match !== "object" ? validators.lastName.validate(input, metadata) : match._0;
  let match$1 = fieldsStatuses.firstName;
  let tmp$1;
  tmp$1 = typeof match$1 !== "object" ? validators.firstName.validate(input, metadata) : match$1._0;
  let value = fieldsStatuses.email;
  let tmp$2;
  tmp$2 = typeof value !== "object" ? ({
      NAME: "Result",
      VAL: validators.email.validate(input, metadata)
    }) : (
      value.TAG === "Dirty" ? ({
          NAME: "Result",
          VAL: value._0
        }) : ({
          NAME: "Validating",
          VAL: value._0
        })
    );
  let match$2 = fieldsStatuses.role;
  let tmp$3;
  tmp$3 = typeof match$2 !== "object" ? validators.role.validate(input, metadata) : match$2._0;
  let lastNameResult = tmp;
  let exit = 0;
  let emailResult = tmp$2;
  if (typeof emailResult === "object") {
    if (emailResult.NAME === "Validating") {
      return {
        TAG: "Validating",
        fieldsStatuses: {
          lastName: {
            TAG: "Dirty",
            _0: lastNameResult,
            _1: "Shown"
          },
          firstName: {
            TAG: "Dirty",
            _0: tmp$1,
            _1: "Shown"
          },
          email: emailResult.NAME === "Result" ? ({
              TAG: "Dirty",
              _0: emailResult.VAL,
              _1: "Shown"
            }) : ({
              TAG: "Validating",
              _0: emailResult.VAL
            }),
          role: {
            TAG: "Dirty",
            _0: tmp$3,
            _1: "Shown"
          }
        },
        collectionsStatuses: undefined
      };
    }
    exit = 2;
  } else {
    exit = 2;
  }
  if (exit === 2 && lastNameResult.TAG === "Ok") {
    let firstNameResult = tmp$1;
    if (firstNameResult.TAG === "Ok") {
      let match$3 = tmp$2;
      if (typeof match$3 === "object" && match$3.NAME === "Result") {
        let emailResult$1 = match$3.VAL;
        if (emailResult$1.TAG === "Ok") {
          let roleResult = tmp$3;
          return {
            TAG: "Valid",
            output: {
              role: roleResult._0,
              email: emailResult$1._0,
              firstName: firstNameResult._0,
              lastName: lastNameResult._0
            },
            fieldsStatuses: {
              lastName: {
                TAG: "Dirty",
                _0: lastNameResult,
                _1: "Shown"
              },
              firstName: {
                TAG: "Dirty",
                _0: firstNameResult,
                _1: "Shown"
              },
              email: {
                TAG: "Dirty",
                _0: emailResult$1,
                _1: "Shown"
              },
              role: {
                TAG: "Dirty",
                _0: roleResult,
                _1: "Shown"
              }
            },
            collectionsStatuses: undefined
          };
        }
      }
    }
  }
  return {
    TAG: "Invalid",
    fieldsStatuses: {
      lastName: {
        TAG: "Dirty",
        _0: lastNameResult,
        _1: "Shown"
      },
      firstName: {
        TAG: "Dirty",
        _0: tmp$1,
        _1: "Shown"
      },
      email: {
        TAG: "Dirty",
        _0: tmp$2.VAL,
        _1: "Shown"
      },
      role: {
        TAG: "Dirty",
        _0: tmp$3,
        _1: "Shown"
      }
    },
    collectionsStatuses: undefined
  };
}

function useForm(initialInput, metadata, onSubmit) {
  let memoizedInitialState = React.useMemo(() => initialState(initialInput), [initialInput]);
  let match = Formality__ReactUpdate.useReducer(memoizedInitialState, (state, action) => {
    if (typeof action !== "object") {
      switch (action) {
        case "BlurLastNameField" :
          let result = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.lastName, validators_lastName, status => {
            let init = state.fieldsStatuses;
            return {
              lastName: status,
              firstName: init.firstName,
              email: init.email,
              role: init.role
            };
          });
          if (result !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurFirstNameField" :
          let result$1 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.firstName, validators_firstName, status => {
            let init = state.fieldsStatuses;
            return {
              lastName: init.lastName,
              firstName: status,
              email: init.email,
              role: init.role
            };
          });
          if (result$1 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$1,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "BlurEmailField" :
          let result$2 = Formality.Async.validateFieldOnBlurWithMetadata(state.input, metadata, state.fieldsStatuses.email, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              lastName: init.lastName,
              firstName: init.firstName,
              email: status,
              role: init.role
            };
          });
          if (result$2 === undefined) {
            return "NoUpdate";
          }
          let value = result$2.email;
          if (typeof value === "object" && value.TAG !== "Dirty") {
            let value$1 = value._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: state.input,
                fieldsStatuses: result$2,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$1,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: result$2,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
          break;
        case "BlurRoleField" :
          let result$3 = Formality.validateFieldOnBlurWithValidatorAndMetadata(state.input, metadata, state.fieldsStatuses.role, validators_role, status => {
            let init = state.fieldsStatuses;
            return {
              lastName: init.lastName,
              firstName: init.firstName,
              email: init.email,
              role: status
            };
          });
          if (result$3 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: result$3,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
        case "Submit" :
          let match = state.formStatus;
          if (typeof match === "object" && match.TAG === "Submitting") {
            return "NoUpdate";
          }
          let apply_validate = validateForm;
          let match$1 = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
          switch (match$1.TAG) {
            case "Valid" :
              let output = match$1.output;
              let error = state.formStatus;
              let tmp;
              tmp = typeof error !== "object" || error.TAG !== "SubmissionFailed" ? undefined : error._0;
              return {
                TAG: "UpdateWithSideEffects",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: {
                    TAG: "Submitting",
                    _0: tmp
                  },
                  submissionStatus: "AttemptedToSubmit"
                },
                _1: param => {
                  let dispatch = param.dispatch;
                  onSubmit(output, {
                    notifyOnSuccess: input => dispatch({
                      TAG: "SetSubmittedStatus",
                      _0: input
                    }),
                    notifyOnFailure: error => dispatch({
                      TAG: "SetSubmissionFailedStatus",
                      _0: error
                    }),
                    reset: () => dispatch("Reset"),
                    dismissSubmissionResult: () => dispatch("DismissSubmissionResult")
                  });
                }
              };
            case "Invalid" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: "Editing",
                  submissionStatus: "AttemptedToSubmit"
                }
              };
            case "Validating" :
              return {
                TAG: "Update",
                _0: {
                  input: state.input,
                  fieldsStatuses: match$1.fieldsStatuses,
                  collectionsStatuses: match$1.collectionsStatuses,
                  formStatus: state.formStatus,
                  submissionStatus: state.submissionStatus
                }
              };
          }
          break;
        case "DismissSubmissionError" :
          let match$2 = state.formStatus;
          if (typeof match$2 !== "object" || match$2.TAG !== "SubmissionFailed") {
            return "NoUpdate";
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Editing",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "DismissSubmissionResult" :
          let match$3 = state.formStatus;
          if (typeof match$3 !== "object") {
            if (match$3 === "Editing") {
              return "NoUpdate";
            }
          } else if (match$3.TAG === "Submitting") {
            return "NoUpdate";
          }
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: "Editing",
              submissionStatus: state.submissionStatus
            }
          };
        case "Reset" :
          return {
            TAG: "Update",
            _0: initialState(initialInput)
          };
      }
    } else {
      switch (action.TAG) {
        case "UpdateLastNameField" :
          let nextInput = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput, metadata, state.fieldsStatuses.lastName, state.submissionStatus, validators_lastName, status => {
                let init = state.fieldsStatuses;
                return {
                  lastName: status,
                  firstName: init.firstName,
                  email: init.email,
                  role: init.role
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateFirstNameField" :
          let nextInput$1 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$1,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$1, metadata, state.fieldsStatuses.firstName, state.submissionStatus, validators_firstName, status => {
                let init = state.fieldsStatuses;
                return {
                  lastName: init.lastName,
                  firstName: status,
                  email: init.email,
                  role: init.role
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateEmailField" :
          let nextInput$2 = action._0(state.input);
          let nextFieldsStatuses = Formality.Async.validateFieldOnChangeInOnChangeModeWithMetadata(nextInput$2, metadata, state.fieldsStatuses.email, state.submissionStatus, validators_email, status => {
            let init = state.fieldsStatuses;
            return {
              lastName: init.lastName,
              firstName: init.firstName,
              email: status,
              role: init.role
            };
          });
          let value$2 = nextFieldsStatuses.email;
          if (typeof value$2 === "object" && value$2.TAG !== "Dirty") {
            let value$3 = value$2._0;
            return {
              TAG: "UpdateWithSideEffects",
              _0: {
                input: nextInput$2,
                fieldsStatuses: nextFieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: state.formStatus,
                submissionStatus: state.submissionStatus
              },
              _1: param => validators_email.validateAsync([
                value$3,
                metadata,
                param.dispatch
              ])
            };
          }
          return {
            TAG: "Update",
            _0: {
              input: nextInput$2,
              fieldsStatuses: nextFieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "UpdateRoleField" :
          let nextInput$3 = action._0(state.input);
          return {
            TAG: "Update",
            _0: {
              input: nextInput$3,
              fieldsStatuses: Formality.validateFieldOnChangeWithValidatorAndMetadata(nextInput$3, metadata, state.fieldsStatuses.role, state.submissionStatus, validators_role, status => {
                let init = state.fieldsStatuses;
                return {
                  lastName: init.lastName,
                  firstName: init.firstName,
                  email: init.email,
                  role: status
                };
              }),
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "ApplyAsyncResultForEmailField" :
          let validator = validators_email;
          let x = state.fieldsStatuses.email;
          if (typeof x !== "object") {
            return "NoUpdate";
          }
          if (x.TAG === "Dirty") {
            return "NoUpdate";
          }
          if (!validator.eq(x._0, action._0)) {
            return "NoUpdate";
          }
          let init = state.fieldsStatuses;
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: {
                lastName: init.lastName,
                firstName: init.firstName,
                email: {
                  TAG: "Dirty",
                  _0: action._1,
                  _1: "Shown"
                },
                role: init.role
              },
              collectionsStatuses: state.collectionsStatuses,
              formStatus: state.formStatus,
              submissionStatus: state.submissionStatus
            }
          };
        case "SetSubmittedStatus" :
          let input = action._0;
          if (input !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: input,
                fieldsStatuses: {
                  lastName: "Pristine",
                  firstName: "Pristine",
                  email: "Pristine",
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: {
                  lastName: "Pristine",
                  firstName: "Pristine",
                  email: "Pristine",
                  role: "Pristine"
                },
                collectionsStatuses: state.collectionsStatuses,
                formStatus: "Submitted",
                submissionStatus: state.submissionStatus
              }
            };
          }
        case "SetSubmissionFailedStatus" :
          return {
            TAG: "Update",
            _0: {
              input: state.input,
              fieldsStatuses: state.fieldsStatuses,
              collectionsStatuses: state.collectionsStatuses,
              formStatus: {
                TAG: "SubmissionFailed",
                _0: action._0
              },
              submissionStatus: state.submissionStatus
            }
          };
        case "MapSubmissionError" :
          let map = action._0;
          let error$1 = state.formStatus;
          if (typeof error$1 !== "object") {
            return "NoUpdate";
          }
          if (error$1.TAG !== "Submitting") {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "SubmissionFailed",
                  _0: map(error$1._0)
                },
                submissionStatus: state.submissionStatus
              }
            };
          }
          let error$2 = error$1._0;
          if (error$2 !== undefined) {
            return {
              TAG: "Update",
              _0: {
                input: state.input,
                fieldsStatuses: state.fieldsStatuses,
                collectionsStatuses: state.collectionsStatuses,
                formStatus: {
                  TAG: "Submitting",
                  _0: map(error$2)
                },
                submissionStatus: state.submissionStatus
              }
            };
          } else {
            return "NoUpdate";
          }
      }
    }
  });
  let dispatch = match[1];
  let state = match[0];
  let match$1 = state.formStatus;
  let tmp;
  tmp = typeof match$1 !== "object" ? false : match$1.TAG === "Submitting";
  return {
    updateLastName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateLastNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateFirstName: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateFirstNameField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateEmail: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateEmailField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    updateRole: (nextInputFn, nextValue) => dispatch({
      TAG: "UpdateRoleField",
      _0: __x => nextInputFn(__x, nextValue)
    }),
    blurLastName: () => dispatch("BlurLastNameField"),
    blurFirstName: () => dispatch("BlurFirstNameField"),
    blurEmail: () => dispatch("BlurEmailField"),
    blurRole: () => dispatch("BlurRoleField"),
    lastNameResult: Formality.exposeFieldResult(state.fieldsStatuses.lastName),
    firstNameResult: Formality.exposeFieldResult(state.fieldsStatuses.firstName),
    emailResult: Formality.Async.exposeFieldResult(state.fieldsStatuses.email),
    roleResult: Formality.exposeFieldResult(state.fieldsStatuses.role),
    input: state.input,
    status: state.formStatus,
    dirty: () => {
      let match = state.fieldsStatuses;
      let tmp = match.lastName;
      if (typeof tmp === "object") {
        return true;
      }
      let tmp$1 = match.firstName;
      if (typeof tmp$1 === "object") {
        return true;
      }
      let tmp$2 = match.email;
      if (typeof tmp$2 === "object") {
        return true;
      }
      let tmp$3 = match.role;
      return typeof tmp$3 === "object";
    },
    valid: () => {
      let apply_validate = validateForm;
      let match = apply_validate(state.input, validators, state.fieldsStatuses, metadata);
      switch (match.TAG) {
        case "Valid" :
          return true;
        case "Invalid" :
          return false;
        case "Validating" :
          return;
      }
    },
    submitting: tmp,
    submit: () => dispatch("Submit"),
    dismissSubmissionError: () => dispatch("DismissSubmissionError"),
    dismissSubmissionResult: () => dispatch("DismissSubmissionResult"),
    mapSubmissionError: map => dispatch({
      TAG: "MapSubmissionError",
      _0: map
    }),
    reset: () => dispatch("Reset")
  };
}

let FormConfig = {
  debounceInterval: 700,
  validators: validators,
  initialFieldsStatuses: initialFieldsStatuses,
  initialFieldStatuses_xxx: initialFieldStatuses_xxx,
  initialCollectionsStatuses: undefined,
  initialState: initialState,
  validateForm: validateForm,
  useForm: useForm
};

function SubusersAddUserForm$AddUserForm(props) {
  let accountDataId = props.accountDataId;
  let match = use$2();
  let addMember = match[0];
  let match$1 = React.useState(() => "");
  let setRegisteredEmail = match$1[1];
  let form = useForm({
    role: undefined,
    email: undefined,
    firstName: undefined,
    lastName: undefined
  }, {
    validateEmail: validate
  }, (output, param) => {
    let notifyOnFailure = param.notifyOnFailure;
    let notifyOnSuccess = param.notifyOnSuccess;
    addMember({
      connections: [SubusersPageAccountsList_account_graphql.makeConnectionId(accountDataId)],
      input: {
        email: output.email,
        firstName: output.firstName,
        lastName: output.lastName,
        role: output.role
      }
    }, undefined, undefined, undefined, (param, param$1) => {
      let addMemberV5 = param.addMemberV5;
      if (addMemberV5 === undefined) {
        return notifyOnFailure(genericErrorMessage);
      }
      switch (addMemberV5.__typename) {
        case "AccountMemberAdded" :
          setRegisteredEmail(param => Scalars.EmailAddress.toString(output.email));
          return notifyOnSuccess(undefined);
        case "NotAuthorizedError" :
          return notifyOnFailure("Only the account owner can add users to the account.");
        case "SubuserLimitReachedForAccount" :
          return notifyOnFailure("You have reached the maximum number of allowed users. Contact support if you need to add more users to this account.");
        case "__unselected" :
          return notifyOnFailure(genericErrorMessage);
      }
    }, undefined, undefined);
  });
  let match$2 = form.roleResult;
  let tmp;
  tmp = match$2 !== undefined ? (
      match$2.TAG === "Ok" ? "Ok" : "Error"
    ) : undefined;
  let match$3 = form.firstNameResult;
  let tmp$1;
  tmp$1 = match$3 !== undefined && match$3.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$3._0
    }) : undefined;
  let match$4 = form.lastNameResult;
  let tmp$2;
  tmp$2 = match$4 !== undefined && match$4.TAG !== "Ok" ? ({
      NAME: "Error",
      VAL: match$4._0
    }) : undefined;
  let tmp$3 = true;
  if (!form.submitting) {
    let match$5 = form.status;
    let tmp$4;
    tmp$4 = typeof match$5 !== "object" ? match$5 !== "Editing" : match$5.TAG === "Submitting";
    tmp$3 = tmp$4;
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("div", {
        children: JsxRuntime.jsx(Form__Components.FormStatusMessageV2.make, {
          status: form.status,
          submissionErrorToString: v => v,
          onSuccessMessage: "An email with instructions has been sent to " + match$1[0],
          resetForm: form.reset,
          dismissSubmissionResult: form.dismissSubmissionResult
        }),
        className: "mb-5"
      }),
      JsxRuntime.jsx(FormV5.FormGroup.make, {
        label: "Role:",
        children: JsxRuntime.jsx(AccountMemberUtils.RoleSelectComponent.make, {
          onChange: value => form.updateRole((formState, value) => ({
            role: value,
            email: formState.email,
            firstName: formState.firstName,
            lastName: formState.lastName
          }), value !== undefined ? value.value : undefined),
          result: tmp,
          value: Stdlib_Option.map(form.input.role, v => AccountMemberUtils.SelectOpts.make(v))
        })
      }),
      JsxRuntime.jsxs(FormV5.FormGroup.make, {
        label: "Email:",
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            placeholderText: "Enter your email",
            onChange: event => form.updateEmail((v, value) => ({
              role: v.role,
              email: value,
              firstName: v.firstName,
              lastName: v.lastName
            }), event.target.value),
            onBlur: param => form.blurEmail(),
            disabled: false,
            status: Form__Helpers.resultAsyncToStatus(form.emailResult),
            value: Stdlib_Option.getOr(form.input.email, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldErrorAsyncV2.make, {
            valid: form.emailResult
          })
        ]
      }),
      JsxRuntime.jsxs(FormV5.FormGroup.make, {
        label: "First name:",
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            type: "text",
            onChange: event => form.updateFirstName((v, value) => ({
              role: v.role,
              email: v.email,
              firstName: value,
              lastName: v.lastName
            }), event.target.value),
            onBlur: param => form.blurFirstName(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.firstNameResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.firstName, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$1
          })
        ]
      }),
      JsxRuntime.jsxs(FormV5.FormGroup.make, {
        label: "Last name:",
        children: [
          JsxRuntime.jsx(Form__Input.make, {
            type: "text",
            onChange: event => form.updateLastName((v, value) => ({
              role: v.role,
              email: v.email,
              firstName: v.firstName,
              lastName: value
            }), event.target.value),
            onBlur: param => form.blurLastName(),
            disabled: form.submitting,
            status: Stdlib_Option.map(form.lastNameResult, x => {
              if (x.TAG === "Ok") {
                return "ok";
              } else {
                return "error";
              }
            }),
            value: Stdlib_Option.getOr(form.input.lastName, "")
          }),
          JsxRuntime.jsx(Form__Components.FieldError.make, {
            valid: tmp$2
          })
        ]
      }),
      JsxRuntime.jsx(FormV5.FormGroup.make, {
        children: JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
          onClick: extra => Form__Helpers.preventDefault(form.submit, extra),
          disabled: tmp$3 || match[1],
          children: "Add user"
        })
      })
    ]
  });
}

let AddUserForm = {
  AddMemberV5Mutation: AddMemberV5Mutation,
  genericErrorMessage: genericErrorMessage,
  FormConfig: FormConfig,
  make: SubusersAddUserForm$AddUserForm
};

function SubusersAddUserForm(props) {
  let currentUserRole = props.currentUserRole;
  let account = RescriptRelay_Fragment.useFragment(SubusersAddUserForm_account_graphql.node, convertFragment, props.account);
  let match = Stdlib_Option.getOr(account.subuserLimitReached, false);
  if (match) {
    return JsxRuntime.jsx(SubusersAddUserForm$SubuserLimitReachedMessage, {});
  } else if (currentUserRole === "OWNER") {
    return JsxRuntime.jsxs("div", {
      children: [
        JsxRuntime.jsx(TMPUIKIT____Page.Subtitle.make, {
          children: "Add User"
        }),
        JsxRuntime.jsx(SubusersAddUserForm$AddUserForm, {
          accountDataId: account.__id
        })
      ],
      className: "mt-8"
    });
  } else {
    return JsxRuntime.jsx(SubusersAddUserForm$OnlyAccountOwnerMessage, {});
  }
}

let make = SubusersAddUserForm;

exports.ValidateEmailAsync = ValidateEmailAsync;
exports.SubuserLimitReachedMessage = SubuserLimitReachedMessage;
exports.OnlyAccountOwnerMessage = OnlyAccountOwnerMessage;
exports.AccountFragment = AccountFragment;
exports.AddUserForm = AddUserForm;
exports.make = make;
/* use Not a pure module */
